import React from 'react';

const PendienteEntrega = () => {
  return (
    <div className="container-fluid mt-4">
      <h1 className="mb-4">
        <i className="bi bi-truck me-2 text-warning"></i>
        Pendientes de Entrega
      </h1>
      <div className="alert alert-info d-flex align-items-center gap-3 shadow-sm" role="alert">
        <i className="bi bi-tools fs-3"></i>
        <div>
          <strong>Sección en desarrollo</strong>
          <div className="small">
            Aquí se listarán los pedidos a proveedores que aún no han ingresado al almacén.
            Estará disponible en una próxima versión.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendienteEntrega;
